import React from 'react';

/*
 *  @Description:   Stateless component that renders a Play icon.
 */

const Play = ( props ) => {

    return (<g id="path">
            <path d="m6.11 20.9 12.5-8.18a0.879 0.871 0 0 0 0-1.41l-12.5-8.2c-0.503-0.329-1.11 0.0774-1.11 0.697v16.4c0 0.638 0.606 1.03 1.11 0.716z"/>
        </g>
    )

};

export default Play;

